




















































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import TabularHeader from '@/modules/shared/components/shared/TabularHeader.vue'
import CampaignStatusView from '@/modules/base-campaign/components/shared/CampaignStatusView.vue'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import AdminContentCampaignTabularActions
  from '@/modules/content-campaign/components/admin/AdminContentCampaignTabularActions.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsis.vue'
import MediaAttachmentDialog from '@/modules/media/components/shared/MediaAttachmentDialog.vue'
import InvoiceStatusView from '@/modules/invoice/components/shared/InvoiceStatusView.vue'
import InvoiceModelTypeView from '@/modules/invoice/components/shared/InvoiceModelTypeView.vue'
import AdminInvoiceActions from '@/modules/invoice/components/admin/table/AdminInvoiceActions.vue'
import InvoicePersonTypeView from '@/modules/invoice/components/shared/InvoicePersonTypeView.vue'
import AdminInvoiceShowTabularActions from '@/modules/invoice/components/admin/AdminInvoiceShowTabularActions.vue'
import TransactionStatusView from '@/modules/transaction/components/shared/TransactionStatusView.vue'
import { TicketResourceType } from '@/modules/ticket/models/ticket-resource.model'
import { adminTicketTabularColumn } from '@/modules/ticket/models/columns/ticket-show-tabular.column'
import TicketStatusView from '@/modules/ticket/components/shared/TicketStatusView.vue'
import AdminDepartmentSearch from '@/modules/department/components/admin/AdminDepartmentSearch.vue'
import AdminUserInfoButton from '@/modules/user/components/admin/AdminUserInfoButton.vue'

@Component({
  components: {
    AdminUserInfoButton,
    AdminDepartmentSearch,
    TicketStatusView,
    TransactionStatusView,
    AdminInvoiceShowTabularActions,
    InvoicePersonTypeView,
    AdminInvoiceActions,
    InvoiceModelTypeView,
    InvoiceStatusView,
    MediaAttachmentDialog,
    TabularHeader,
    AdminCampaignStatus: CampaignStatusView,
    DateTooltipped,
    AdminContentCampaignTabularActions,
    TextEllipsis
  }
})
export default class AdminTicketShowTabular extends Vue {
  @Prop({ required: true }) ticket: TicketResourceType

  protected columns = adminTicketTabularColumn()

  get ticketData() {
    return this.ticket.data
  }

}
